import { NgModule } from '@angular/core';
import { NguFullcalendar } from './ngu-fullcalendar.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [FormsModule, ReactiveFormsModule],
  exports: [NguFullcalendar],
  declarations: [NguFullcalendar],
  providers: []
})
export class NguFullcalendarModule {}
